import { Component, Input, Output, EventEmitter } from "@angular/core";

// TODO: eslint fix
/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({
	selector: "bp-segment-button",
	templateUrl: "./bp-segment-button.component.html",
	styleUrls: ["./bp-segment-button.component.scss"],
	standalone: false
})
export class BpSegmentButtonComponent {
	/**
	 * The available options
	 */
	@Input()
	public options: BpSegmentButtonOption[] = [];

	/**
	 * Styling light
	 */
	@Input()
	public light: boolean = false;

	/**
	 * Display icon
	 */
	@Input()
	public icon: boolean = false;

	/**
	 * The currently selected option
	 */
	@Input()
	public set selected(option: BpSegmentButtonOption) {
		this._selected = option;
		this.selectedChange.emit(option);
		this.selectedValueChange.emit(option.value);
	}
	/**
	 * The currently selected option
	 */
	public get selected(): BpSegmentButtonOption {
		return this._selected;
	}
	private _selected: BpSegmentButtonOption;

	/**
	 * Emitted whenever the selection changes
	 */
	@Output()
	public selectedChange: EventEmitter<BpSegmentButtonOption> = new EventEmitter<BpSegmentButtonOption>();

	/**
	 * Sets the selected option to the first one that has this value
	 *
	 * Use selected.value for get opterations
	 */
	@Input()
	public set selectedValue(value: any) {
		if (this.options) {
			this.selected = this.options.find((o) => o.value === value);
		}
	}

	/**
	 * Bigger space between buttons. styling option.
	 */

	@Input()
	public isSpaced: boolean = false;

	/**
	 * Emits the selected Value whenever it changes
	 */
	@Output()
	public selectedValueChange: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * Selects an option
	 * @param option the option to select
	 */
	public onOptionClick(option): void {
		this.selected = option;
	}
}

export interface BpSegmentButtonOption {
	/**
	 * The text to display
	 */
	name: string;
	/**
	 * The value to emit
	 */
	value: any;
}
